import { inject, Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { map, Observable } from 'rxjs';
import { ENV_CONFIG } from '@ps/core-config';
import { CurrencyListResponseDto } from './dtos/company.dto';
import { CurrencyMapper } from './mappers/currency.mapper';
import { Currency } from '../models/company.model';

@Injectable({ providedIn: 'root' })
export class CurrencyApi {
  private readonly _httpClient = inject(HttpClient);
  private readonly _environmentConfig = inject(ENV_CONFIG);
  private readonly _baseUrl = this._environmentConfig.pureSpectrum.url;
  private readonly _mapper = new CurrencyMapper();

  public currencies(): Observable<Currency[]> {
    return this._httpClient
      .get<CurrencyListResponseDto>(
        `${this._baseUrl}/international_currency/companies`,
      )
      .pipe(map((response) => this._mapper.fromDtoList(response.currencies)));
  }
}
